import * as React from 'react';

interface IProps {
    className?: string;
}

export const BaseCheck: React.FC<IProps> = ({ className }) => (
    <svg
        className={className}
        version="1.1"
        viewBox="0 0 17 13"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            fill="none"
            fillRule="evenodd"
            id="Mobile---default"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        >
            <g
                id="Personalized"
                strokeWidth="2.5"
                transform="translate(-35.000000, -377.000000)"
            >
                <g id="Package" transform="translate(15.000000, 177.000000)">
                    <g
                        id="Options"
                        transform="translate(22.000000, 185.000000)"
                    >
                        <polyline
                            id="Stroke-1"
                            points="0 21.5 4.5 26 13.5 17"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
